<template>
    <div class="addapi">
        <el-row  style="padding:10px 35px 0px 35px;margin-bottom: 22px;">
            <i style="color: #666;" class="el-icon-caret-left" @click="goBack"></i>
            <span style="font-size: 14px;color: #666;" @click="goBack">返回</span>
            <span style="margin: 0px 15px;">|</span>
            <span style="font-size: 14px;color:#333">开放平台/ {{wherefrom}}</span>
        </el-row>
        <el-row style="padding:0px 35px 0px 35px;border-bottom: 1px solid #eee;margin-bottom: 22px;height: 45px;">
            <span style="font-size: 16px;color: #4A90E2;border-bottom: 2px solid #4A90E2;padding-bottom: 15px;">{{wherefrom}}</span>
        </el-row>
        <el-form :model="formData" :rules="formRules" ref="form" label-width="120px">
            <el-form-item style="width: 75%;" label="API名称 " prop="name">
                <el-input :disabled="ifdetail" style="width: 280px"  v-model="formData.name" placeholder="请输入API名称" label="API名称"></el-input>
            </el-form-item >
            <el-form-item style="width: 75%;" label="API简介 " prop="brief">
                <el-input :disabled="ifdetail" style="width: 280px" v-model="formData.brief" placeholder="请输入API简介" label="API简介"></el-input>
            </el-form-item >
            <el-form-item style="width: 75%;" label="接口版本 " prop="version">
                <el-input :disabled="ifdetail" style="width: 280px" v-model="formData.version" placeholder="请输入接口版本" label="接口版本"></el-input>
            </el-form-item >
            <!-- <el-form-item style="width: 75%;" label="接口图标:" prop="apiImg">
                <upload
                    ref="test"
                    class="upload-file"
                    :file-list.sync="apiImg"
                    :size="10"
                    :limit="1"
                    :multiple="false"
                    type="picture-card"
                    accept=".jpg,.jpeg,.png"
                />
            </el-form-item> -->
            <el-form-item style="width: 75%;" label="接口路径 " prop="url">
                <el-select @change="methodchange" :disabled="ifdetail" v-model="formData.method" style="width: 100px;margin-right: 10px;">
                   <el-option
                   v-for="item in options"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value"
                   >
                 </el-option>
                </el-select>
               <el-input  v-model="formData.domain" :disabled="ifdetail" style="width: 280px;margin-right: 10px;" placeholder="请输入接口域名" label="接口域名"></el-input>
               <el-input v-model="formData.url" :disabled="ifdetail" style="width: 280px;" placeholder="请输入接口路径" label="接口路径"></el-input>
           </el-form-item >

           <el-row style="display:flex;justify-content:center;margin-bottom:10px;">
             <el-radio-group v-model="urlRequestRadio" size="medium">
               <el-radio-button label="body" v-if="formData.method!='GET'">Body</el-radio-button>
               <el-radio-button label="query">Query</el-radio-button>
               <el-radio-button label="headers">Headers</el-radio-button>
             </el-radio-group>
           </el-row>
           <el-form-item style="width: 75%;margin-top:20px;margin-bottom:20px;" label="请求Body " prop="body"  v-show="urlRequestRadio=='body'">
               <el-row>
                <el-radio :disabled="ifdetail" v-model="requestTypeRadio" label="1">json</el-radio>
                <el-radio :disabled="ifdetail" v-model="requestTypeRadio" label="2">form</el-radio>
               </el-row>
               <editor ref='myEditor1'  v-if="requestTypeRadio==1" v-model="formData.body"  @init="editorInit" lang="javascript" theme="xcode" width="100%" height="300"></editor>
               <el-button :disabled="ifdetail" v-if="requestTypeRadio==2" @click="addFile" type="primary">添加form</el-button>
               <el-row v-for="(item,index) in fileArr" v-if="requestTypeRadio==2" style="margin-top: 10px;" :key="index">
                    <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.name" placeholder="参数名称" label="参数名称"></el-input>
                    <el-select :disabled="ifdetail" v-model="item.type" style="width: 100px;margin-right: 10px;">
                        <el-option
                        v-for="optionitem in fileType"
                        :key="optionitem.value"
                        :label="optionitem.label"
                        :value="optionitem.value"
                        >
                        </el-option>
                    </el-select>
                    <el-select :disabled="ifdetail" v-model="item.ifrequired" style="width: 100px;margin-right: 10px;">
                        <el-option
                        v-for="optionitem in ifrequireoptions"
                        :key="optionitem.value"
                        :label="optionitem.label"
                        :value="optionitem.value"
                        >
                        </el-option>
                    </el-select>
                    <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.shili" placeholder="参数示例" label="参数示例"></el-input>
                    <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.memo" placeholder="备注" label="备注"></el-input>
                    <i class="el-icon-delete" @click="filearrdelete(index)"></i>
                </el-row>
            </el-form-item >
           <el-form-item style="width: 100%;margin-top:20px;margin-bottom:20px;" label="请求Header " prop="header" v-show="urlRequestRadio=='headers'">
               <el-button :disabled="ifdetail" @click="addUrlHeader" type="primary">添加header</el-button>
               <el-row v-for="(item,index) in urlHeaderArr" :key="index" style="margin-top: 10px;">
                   <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.name" placeholder="参数名称" label="参数名称"></el-input>
                   <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.value" placeholder="参数值" label="参数值"></el-input>
                   <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.shili" placeholder="参数示例" label="参数示例"></el-input>
                   <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.memo" placeholder="备注" label="备注"></el-input>
                   <i v-if="!ifdetail" class="el-icon-delete" @click="urlarrdelete(index)"></i>
               </el-row>
           </el-form-item >
           <el-form-item style="width: 100%;margin-top:20px;margin-bottom:20px;" label="请求Query" prop="header"  v-show="urlRequestRadio=='query'">
               <el-button :disabled="ifdetail" @click="addUrlQuery" type="primary">添加Query</el-button>
               <el-row v-for="(item,index) in urlQueryArr" :key="index" style="margin-top: 10px;">
                   <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.name" placeholder="参数名称" label="参数名称"></el-input>
                   <el-select :disabled="ifdetail" v-model="item.ifrequired" style="width: 100px;margin-right: 10px;">
                       <el-option
                       v-for="optionitem in ifrequireoptions"
                       :key="optionitem.value"
                       :label="optionitem.label"
                       :value="optionitem.value"
                       >
                       </el-option>
                   </el-select>
                   <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.shili" placeholder="参数示例" label="参数示例"></el-input>
                   <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.memo" placeholder="备注" label="备注"></el-input>
                   <i v-if="!ifdetail" class="el-icon-delete" @click="urlqueryarrdelete(index)"></i>
               </el-row>
           </el-form-item >
           <el-form-item style="width: 75%;" label="响应结果 " prop="response" >
               <editor ref='myEditor2' v-model="formData.response"  @init="editorInit" lang="javascript" theme="xcode" width="100%" height="300"></editor>
           </el-form-item >
            <div v-if="!ifdetail">
              <el-form-item style="width: 75%;" label="启用HTTP " prop="httpStatus" v-if="ifManager">
                <el-checkbox :disabled="ifdetail" true-label='1' false-label='0' @change="httpStatusChange" v-model="formData.httpStatus"></el-checkbox>
              </el-form-item >
              <el-form-item style="width: 75%;" label="目标路径 " prop="targetUrl" v-show="formData.httpStatus==1&&ifManager">
                <el-select :disabled="ifdetail"  v-model="formData.http.method" @change="httpMethodChange" style="width: 100px;margin-right: 10px;">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input :disabled="ifdetail"  v-model="formData.http.domain" style="width: 280px;margin-right: 10px;" placeholder="请输入接口域名" label="接口域名"></el-input>
                <el-input :disabled="ifdetail"  v-model="formData.http.url" style="width: 280px;" placeholder="请输入接口路径" label="接口路径"></el-input>
              </el-form-item >
              <el-row class="boxone" style="display:flex;justify-content:center;margin-bottom:10px;" v-if="(formData.httpStatus==1)&&(ifManager)">
                <el-radio-group v-model="targetUrlRequestRadio" size="medium">
                  <el-radio-button label="body" v-if="formData.http.method!='GET'">Body</el-radio-button>
                  <el-radio-button label="query">Query</el-radio-button>
                  <el-radio-button label="headers">Headers</el-radio-button>
                </el-radio-group>
              </el-row>
              <el-form-item style="width: 75%;margin-top:20px;margin-bottom:20px;" label="请求Body " prop="body"  v-show="formData.httpStatus==1&&targetUrlRequestRadio=='body'&&ifManager">
                <el-row>
                  <el-radio :disabled="ifdetail" v-model="httprequestTypeRadio" label="1">json</el-radio>
                  <el-radio :disabled="ifdetail" v-model="httprequestTypeRadio" label="2">form</el-radio>
                </el-row>
                <editor ref='myEditor3' v-if="httprequestTypeRadio==1" v-model="formData.http.body"  @init="editorInit" lang="javascript" theme="xcode" width="100%" height="300"></editor>
                <el-button :disabled="ifdetail" v-if="httprequestTypeRadio==2" @click="httpaddFile" type="primary">添加form</el-button>
                <el-row v-for="(item,index) in httpfileArr" v-if="httprequestTypeRadio==2" style="margin-top: 10px;" :key="index">
                  <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.name" placeholder="参数名称" label="参数名称"></el-input>
                  <el-select :disabled="ifdetail" v-model="item.type" style="width: 100px;margin-right: 10px;">
                    <el-option
                      v-for="optionitem in fileType"
                      :key="optionitem.value"
                      :label="optionitem.label"
                      :value="optionitem.value"
                    >
                    </el-option>
                  </el-select>
                  <el-select :disabled="ifdetail" v-model="item.ifrequired" style="width: 100px;margin-right: 10px;">
                    <el-option
                      v-for="optionitem in ifrequireoptions"
                      :key="optionitem.value"
                      :label="optionitem.label"
                      :value="optionitem.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.shili" placeholder="参数示例" label="参数示例"></el-input>
                  <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.memo" placeholder="备注" label="备注"></el-input>
                  <i class="el-icon-delete" @click="httpfilearrdelete(index)"></i>
                </el-row>
              </el-form-item >
              <el-form-item style="width: 100%;margin-top:20px;margin-bottom:20px;" label="请求Header " prop="header" v-show="formData.httpStatus==1&&targetUrlRequestRadio=='headers'&&ifManager">
                <el-button :disabled="ifdetail" @click="addTargetUrlHeader" type="primary">添加header</el-button>
                <el-row v-for="(item,index) in targetUrlHeaderArr" :key="index" style="margin-top: 10px;">
                  <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.name" placeholder="参数名称" label="参数名称"></el-input>
                  <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.value" placeholder="参数值" label="参数值"></el-input>
                  <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.shili" placeholder="参数示例" label="参数示例"></el-input>
                  <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.memo" placeholder="备注" label="备注"></el-input>
                  <i v-if="!ifdetail" class="el-icon-delete" @click="targeturlarrdelete(index)"></i>
                </el-row>
              </el-form-item >
              <el-form-item style="width: 100%;margin-top:20px;margin-bottom:20px;" label="请求Query " prop="header"  v-show="formData.httpStatus==1&&targetUrlRequestRadio=='query'&&ifManager">
                <el-button :disabled="ifdetail" @click="addTargetUrlQuery" type="primary">添加Query</el-button>
                <el-row v-for="(item,index) in targetUrlQueryArr" :key="index" style="margin-top: 10px;">
                  <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.name" placeholder="参数名称" label="参数名称"></el-input>
                  <el-select :disabled="ifdetail" v-model="item.ifrequired" style="width: 100px;margin-right: 10px;">
                    <el-option
                      v-for="optionitem in ifrequireoptions"
                      :key="optionitem.value"
                      :label="optionitem.label"
                      :value="optionitem.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.shili" placeholder="参数示例" label="参数示例"></el-input>
                  <el-input :disabled="ifdetail" style="width:140px;margin-right: 10px;"  v-model="item.memo" placeholder="备注" label="备注"></el-input>
                  <i v-if="!ifdetail" class="el-icon-delete" @click="targetUrlqueryarrdelete(index)"></i>
                </el-row>
              </el-form-item >

              <el-form-item style="width: 75%;" label="响应结果 " prop="response" v-show="formData.httpStatus==1&&ifManager">
                <editor ref='myEditor4' v-model="formData.http.response" @init="editorInit" lang="javascript" theme="xcode" width="100%" height="300"></editor>
              </el-form-item >
            </div>
            <div v-if="!ifdetail">
              <el-form-item style="width: 75%;" label="启用RPC " prop="rpcStatus"  v-if="ifManager">
                <el-checkbox :disabled="ifdetail" true-label='1' false-label='0' @change="rpcStatusChange" v-model="formData.rpcStatus"></el-checkbox>
              </el-form-item >
              <el-form-item style="width: 75%;" label="地址 " prop="address" v-show="formData.rpcStatus==1&&ifManager">
                <el-input :disabled="ifdetail"  style="width: 280px;" v-model="formData.rpc.address" placeholder="请输入地址" label="地址"></el-input>
              </el-form-item >
              <el-form-item style="width: 75%;" label="接口名称 " prop="interface" v-show="formData.rpcStatus==1&&ifManager">
                <el-input :disabled="ifdetail"  style="width: 280px;" v-model="formData.rpc.interface" placeholder="请输入接口名称" label="接口名称"></el-input>
              </el-form-item >
              <el-form-item style="width: 75%;" label="请求参数 " prop="request" v-show="formData.rpcStatus==1&&ifManager">
                <!-- <vue-json-editor  v-model="formData.request"  lang="zh" disabled="true"/> -->
                <editor ref='myEditor5' v-model="formData.rpc.request"  @init="editorInit" lang="javascript" theme="xcode" width="100%" height="300"></editor>
              </el-form-item >
              <el-form-item style="width: 75%;" label="响应结果 " prop="response" v-show="formData.rpcStatus==1&&ifManager">
                <editor ref='myEditor6' v-model="formData.rpc.response"  @init="editorInit" lang="javascript" theme="xcode" width="100%" height="300"></editor>
              </el-form-item >
            </div>
            <el-form-item style="width: 75%;" label="备注 " prop="remark">
                <el-input type="textarea" :disabled="ifdetail"  style="width: 280px;" v-model="formData.remark" placeholder="请输入备注" label="备注"></el-input>
            </el-form-item >
        </el-form>
        <el-row style="padding-left: 10%;margin-bottom: 50px;" v-if="!ifdetail">
            <el-button type="primary" @click="addApi">保存</el-button>
        </el-row>
    </div>
</template>
<script>
    import {addApi,changeApi} from '@/api/operateapi'
    import Upload from '@/components/Upload'
    import { hasAuth } from '@/utils/common'
    import editor from 'vue2-ace-editor-support-chinese'
    export default {
        name:'Addapi',
        components: {
             Upload,
             editor
            },
        data(){
            const validataList =(rule,value,callback)=>{
                console.log(this.formData.httpStatus)
                if (this.formData.httpStatus==1 || this.formData.rpcStatus ==1) {
                  callback()
                } else {
                  callback(new Error('http和rpc需选其中一个'))
                }
            }
            return {
                fileType:[
                    {
                        value:'text',
                        label:'text'
                    },
                    {
                        value:'file',
                        label:'file'
                    }
                ],
                requestTypeRadio:'1',
                httprequestTypeRadio:'1',
                wherefrom:'新增API',
                content:'123',
                auths:[
                    {
                      level:4,
                      auth:'07000100'
                    }
                ],
                urlRequestRadio:'body',
                targetUrlRequestRadio:'body',
                ifManager:false,
                fileArr:[{}],
                httpfileArr:[{}],
                urlHeaderArr:[
                    {}
                ],
                urlQueryArr:[
                    {}
                ],
                targetUrlHeaderArr:[
                    {}
                ],
                targetUrlQueryArr:[
                    {}
                ],
                ifrequireoptions:[
                    {
                        label:'必需',
                        value:'required'
                    },
                    {
                        label:'非必需',
                        value:'norequired'
                    }
                ],
                options:[
                 {
                     label:'POST',
                     value:'POST'
                 },
                 {
                     label:'GET',
                     value:'GET'
                 },
                 {
                     label:'PUT',
                     value:'PUT'
                 },
                 {
                     label:'DELETE',
                     value:'DELETE'
                 },
                 {
                     label:'HEAD',
                     value:'HEAD'
                 },
                 {
                     label:'OPTIONS',
                     value:'OPTIONS'
                 },
                 {
                     label:'PATCH',
                     value:'PATCH'
                 }
                ],
                ifdetail:false,
                formData:{
                    name:'',
                    brief:'',
                    version:'',
                    httpStatus:'1',
                    http:{
                        body:'',
                        method:'',
                        url:'',
                        response:'',
                        domain:''
                    },
                    domain:'',
                    //header:'',
                    body:'',
                    response:'',
                    remark:'',
                    rpcStatus:'0',
                    rpc:{
                        address:'',
                        interface:'',
                        request:'',
                        response:''
                    },
                    //url:'',
                    icon:'',
                },
                routeJson:{
                    name:'123',
                    haha:1,
                    ifshow:true
                },
                apiImg:[],
                formRules:{
                    name:[{required:true,message:'必填',trigger:'blur'}],
                    url:[{required:true,message:'必填',trigger:'blur'}],
                    httpStatus: [{ validator: validataList }],
                    rpcStatus:  [{ validator: validataList }]
                },
            }
        },
        watch: {
            apiImg(val) {
              console.log(this.apiImg)
              if (this.apiImg && this.apiImg.length > 0 && this.apiImg[0].percentage === 100) {
                this.formData.icon = this.apiImg[0].response.name;
                this.$refs['form'].validate((valid) => {
                    console.log('tijiao')
                  if (valid) {
                    //this.form['fileName'] = this.form['lotNum']+ '_' +this.form['code'];
                    if(this.$route.params['row']){
                          changeApi(this.formData).then((res)=>{
                              console.log(res)
                              this.$router.go(-1);
                          })
                      }else{
                          addApi(this.formData).then((res)=>{
                              console.log(res)
                              this.$router.go(-1);
                          })
                      }
                  }
                })
                //this.form.id = this.fileList[0].uid.toString()
              } else {
                this.formData.icon = ''
                //this.form.id = ''
              }

            }
          },
        mounted(){
            if(this.ifdetail){
                let editor=[];
                for(let i=0;i<7;i++){
                    if(this.$refs[`myEditor${i}`]){
                        console.log(this.$refs[`myEditor${i}`])
                        editor.push(this.$refs[`myEditor${i}`].editor)
                    }
                }
                console.log(editor)
                for(let i=0;i<editor.length;i++){
                    if(editor[i]){
                        editor[i]['textInput'].setReadOnly(true);
                    }
                }
            }

        },
        created(){
            console.log(this.$route.params['row']);
            this.ifdetail=this.$route.params['from']=='detail'?true:false;
            if(this.$route.params['from']=='add'){
                this.wherefrom='新增API';
            }else if(this.$route.params['from']=='detail'){
                this.wherefrom='API详情';
            }else{
                this.wherefrom='修改API';
            }

            this.ifManager=hasAuth(this.auths[0].level,this.auths[0].auth);
            //this.ifManager=true;
            let row=JSON.parse(window.localStorage.getItem('row'));
            // console.log('ifmanager');
            // console.log(this.ifManager);
            // console.log('row')
            // console.log(row)
            if(row['method']=='GET'){
                this.urlRequestRadio='query';
            }else{
                this.urlRequestRadio='body';
            }
            if(row['http']['method']=='GET'){
                this.targetUrlRequestRadio='query';
            }else{
                this.targetUrlRequestRadio='body';
            }
            if(row['name']){
                row['httpStatus']=String(row['httpStatus']);
                row['rpcStatus']=String(row['rpcStatus']);
                this.formData={...row};
                this.urlHeaderArr=JSON.parse(row['header']);
                this.urlQueryArr=JSON.parse(row['query']);
                this.targetUrlHeaderArr=JSON.parse(row['http']['header']);
                this.targetUrlQueryArr=JSON.parse(row['http']['query']);
                let body=JSON.parse(row['body']);
                this.requestTypeRadio=body['type'];
                if(body['type']=='2'){
                    this.fileArr=body['content'];
                }else{
                    this.formData['body']=body['content'];
                }

                if(this.formData['httpStatus']==0){
                    this.formData['http']['body']='';
                }else{
                    let httpbody=JSON.parse(row['http']['body']);
                    this.httprequestTypeRadio=httpbody['type'];
                    if(httpbody['type']=='2'){
                        this.httpfileArr=httpbody['content'];
                    }else{
                        this.formData['http']['body']=httpbody['content'];
                    }
                }
                // let fb={}
                // fb.name= this.$route.params['row'].icon;
                // fb.url = process.env.VUE_APP_OSS_CDN + this.$route.params['row'].icon;
                // fb.status = 'success'
                // this.apiImg = []
                // this.apiImg.push(fb);
                // console.log(this.apiImg)
            }
        },
        methods:{
            methodchange(){
                if(this.formData['method']=='GET'){
                    this.urlRequestRadio='query';
                }
            },
            httpMethodChange(){
                if(this.formData.http['method']=='GET'){
                    this.targetUrlRequestRadio='query';
                }
            },
            rpcStatusChange(val){
                if(val=='1'){
                    this.formData.httpStatus='0';
                }
            },
            httpStatusChange(val){
                if(val=='1'){
                    this.formData.rpcStatus='0';
                }
            },
            goBack(){
                this.$router.go(-1);//返回上一层
            },
            addFile(){
                this.fileArr.push({name:'',type:'text',ifrequired:'',shili:'',memo:''})
            },
            httpaddFile(){
                this.httpfileArr.push({name:'',type:'text',ifrequired:'',shili:'',memo:''})
            },
            addUrlHeader(){
                this.urlHeaderArr.push({name:'',value:'',shili:'',memo:''})
            },
            addUrlQuery(){
                this.urlQueryArr.push({name:'',required:'',shili:'',memo:''})
            },
            filearrdelete(index){
                this.fileArr.splice(index,1)
            },
            httpfilearrdelete(index){
                this.httpfileArr.splice(index,1)
            },
            urlarrdelete(index){
                this.urlHeaderArr.splice(index,1)
            },
            urlqueryarrdelete(index){
                this.urlQueryArr.splice(index,1)
            },
            addTargetUrlHeader(){
                this.targetUrlHeaderArr.push({name:'',value:'',shili:'',memo:''})
            },
            targeturlarrdelete(index){
                this.targetUrlHeaderArr.splice(index,1)
            },
            addTargetUrlQuery(){
                this.targetUrlQueryArr.push({name:'',required:'',shili:'',memo:''})
            },
            targetUrlqueryarrdelete(index){
                this.targetUrlQueryArr.splice(index,1)
            },
            editorInit () {
                require('brace/ext/language_tools') //language extension prerequsite...
                require('brace/mode/html')
                require('brace/mode/javascript')    //language
                require('brace/mode/less')
                require('brace/theme/xcode')
                //require('brace/snippets/javascript') //snippet
            },
            onJsonChange(data){
                console.log(data)
            },
            onJsonSave(data){
                console.log(data)
            },
            addApi(){
                // console.log(this.formData);
                // console.log(this.apiImg);
                // console.log(this.$refs.jsoneditor)
                this.formData['rpcStatus']=Number(this.formData['rpcStatus']);
                this.formData['httpStatus']=Number(this.formData['httpStatus']);
                if(this.requestTypeRadio=='1'){
                    this.formData['body']=JSON.stringify({
                        type:'1',
                        content:this.formData['body']
                    })
                }else{
                    this.formData['body']=JSON.stringify({
                        type:'2',
                        content:this.fileArr
                    })
                }
                this.formData['header']=JSON.stringify(this.urlHeaderArr);
                this.formData['query']=JSON.stringify(this.urlQueryArr);
                if(this.formData['httpStatus']==0){
                    this.formData['http']['header']=JSON.stringify([]);
                    this.formData['http']['query']=JSON.stringify([]);
                    this.formData['http']['body']=JSON.stringify({});
                }else{
                    this.formData['http']['header']=JSON.stringify(this.targetUrlHeaderArr);
                    this.formData['http']['query']=JSON.stringify(this.targetUrlQueryArr);
                    if(this.httprequestTypeRadio=='1'){
                        this.formData['http']['body']=JSON.stringify({
                            type:'1',
                            content:this.formData['http']['body']
                        })
                    }else{
                        this.formData['http']['body']=JSON.stringify({
                            type:'2',
                            content:this.httpfileArr
                        })
                    }
                }
                if(this.formData['rpcStatus']==0){
                    this.formData['rpc']['address']='';
                    this.formData['rpc']['interface']='';
                    this.formData['rpc']['request']='';
                    this.formData['rpc']['response']='';
                }
                console.log(this.formData)
                this.$refs['form'].validate((valid) => {
                    //console.log(valid);
                    if (valid) {
                      if(this.apiImg['length']>0){
                        let fileName = this.formData['name']+ '_' +this.formData['version'];
                        this.$refs.test.submitUpload(fileName);
                      }else{
                        if(this.$route.params['row']){
                            changeApi(this.formData).then((res)=>{
                                //console.log(res)
                                this.$router.go(-1);
                            })
                        }else{
                            console.log(this.formData)
                            addApi(this.formData).then((res)=>{
                                //console.log(res)
                                this.$router.go(-1);
                            })
                        }
                      }
                    } else {
                      this.formData.body = ''
                      this.formData.http.body = ''
                    }
                })
            }
        }
    }
</script>
<style>
.addapi{
    padding-left:15px!important;
}
.beijinghei>.el-input__inner{
    background-color: #eee;
}
.addapi .el-input.is-disabled .el-input__inner{
  background-color: #fff!important;
  border-color: #E4E7ED;
  color: #333!important;
  cursor: not-allowed;
}
/* .el-select>.el-input >.el-input__inner{
    background-color: #eee;
} */
</style>
